import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

// import { animateScroll as scroll } from 'react-scroll';

import {
  getEventsList,
  statesListSelector,
} from '../../redux/selectors/common-selectors';
import MapContainer from '../../components/MapContainer/MapContainer';
import SimpleTextList from '../../components/SimpleTextList/SimpleTextList';
// import LocationInput from '../../components/LocationInput/LocationInput';
import CalendarContainer from '../../components/CalendarContainer/CalendarContainer';
import ButtonIcon from '../../components/ButtonIcon/ButtonIcon';

import {
  getWeekObjArrByDate,
  getFormatedDate,
  FORMATED_TODAY,
} from '../../utils/date-utils';
import {
  getEventsToShow,
  getCurrentCalendarValue,
} from '../../utils/events-utils';

import styles from './ProtestsList.module.scss';
import DropdownSelector from '../../components/dropdown-selector/DropdownSelector';
import EventsList from '../../components/EventsList/EventsList';

const ProtestsList = () => {
  const week = getWeekObjArrByDate();

  const events = useSelector(getEventsList);
  const statesList = useSelector(statesListSelector);

  const [showingCalendar, setShowingCalendar] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedDateIndex, setSelectedDateIndex] = useState(0);
  const [selectedSuggestedState, setSelectedSuggestedState] = useState('');
  const [selectedDateByCalendar, setSelectedDateByCalendar] = useState(
    FORMATED_TODAY
  );
  const [weekToUse, setWeekToUse] = useState(week);

  // Handle when selected date by calendar changes
  // should update the week to use and the selected index and
  useEffect(() => {
    const formatedSelectedDateByCalendar = getFormatedDate({
      date: selectedDateByCalendar,
      format: 'YYYY/MM/DD',
    });
    const isformatedSelectedDateByCalendarInInitWeek = weekToUse.some(
      (dayObj) => {
        const formatedDate = getFormatedDate({
          date: dayObj.day,
          format: 'YYYY/MM/DD',
        });
        return formatedDate === formatedSelectedDateByCalendar;
      }
    );

    // If selected date is in current week do not modify week but the selected index
    if (isformatedSelectedDateByCalendarInInitWeek) {
      // look for the index
      // TODO: Refactor this
      let nextIndex = -1;
      weekToUse.forEach((dayObj, index) => {
        const formatedDate = getFormatedDate({
          date: dayObj.day,
          format: 'YYYY/MM/DD',
        });
        if (formatedDate === formatedSelectedDateByCalendar) {
          nextIndex = index;
        }
      });
      setSelectedDateIndex(nextIndex);
    } else {
      setSelectedDateIndex(0);
      const nextWeek = getWeekObjArrByDate({
        startdate: moment(selectedDateByCalendar),
      });
      setWeekToUse(nextWeek);
    }

    setSelectedEvent(null);
  }, [selectedDateByCalendar, weekToUse]);

  // Handle when selected date index changes
  // should update the date to use in calendar
  useEffect(() => {
    const nextDateForCalendar = getFormatedDate({
      date: weekToUse[selectedDateIndex].day,
      format: 'YYYY/MM/DD',
    });
    setSelectedEvent(null);
    setSelectedDateByCalendar(new Date(nextDateForCalendar));
  }, [selectedDateIndex, weekToUse]);

  const eventsToShow = getEventsToShow({
    useFakeData: false,
    initEvents: [...events],
    selectedDateByCalendar,
    selectedSuggestedState,
    weekToUse: [...weekToUse],
    selectedDateIndex,
  });

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    document.getElementById('wrapper').scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <div id="wrapper" className={styles.wrapper}>
      <div className={styles.mapWrapper}>
        <MapContainer events={eventsToShow} selectedEvent={selectedEvent} />
        <ButtonIcon
          iconName="CALENDAR"
          onClick={() => setShowingCalendar((value) => !value)}
          containerStyle={styles.buttonIconWrapper}
        />
        <div className={styles.dropdownWrapper}>
          <DropdownSelector
            listData={statesList}
            fontStyle="thin"
            onSelected={setSelectedSuggestedState}
            inputBorderStyle={styles.dropdownInputBorderStyle}
          />
        </div>
      </div>
      <div className={styles.content}>
        <SimpleTextList
          list={weekToUse}
          selectedItemIndex={selectedDateIndex}
          onClickItem={setSelectedDateIndex}
        />
        <EventsList
          events={eventsToShow}
          onEveryEventClick={handleSelectEvent}
        />
      </div>
      {showingCalendar && (
        <div className={styles.calendarWrapper}>
          <CalendarContainer
            onClose={() => setShowingCalendar(false)}
            currentValue={getCurrentCalendarValue({ selectedDateByCalendar })}
            onSelectedDate={(selectedDate) =>
              setSelectedDateByCalendar(selectedDate)
            }
          />
        </div>
      )}
    </div>
  );
};

export default ProtestsList;
